// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pa-1";
export var stateContainer = "_pa-0";